import { getProvinceByIdRequest } from "../../data/provinceApi";

function getPayloadData(response) {
  if (response?.data && !Array.isArray(response.data)) {
    return response.data;
  }

  if (response?.data?.data && !Array.isArray(response.data.data)) {
    return response.data.data;
  }

  return null;
}

export async function getProvinceByIdUseCase(id) {
  if (!id) {
    throw new Error("El id es obligatorio.");
  }

  const province = getPayloadData(await getProvinceByIdRequest(id));

  if (!province) {
    throw new Error("No se pudo cargar la provincia.");
  }

  return province;
}
